import iconCurrencyRub from '../assets/images/icons/currency-rub.svg';

const CURRENCY_SYMBOLS = {
    'RUR': { text: '₽', icon: iconCurrencyRub },
    'RUB': { text: '₽', icon: iconCurrencyRub },
    'р.': { text: '₽', icon: iconCurrencyRub },
};

const getFloat = value => {
    return Number(parseFloat(value).toFixed(2));
};

export const baseCurrency = number => {
    const string = String(number);
    const [first, last] = string.split('.');
    const formatted = first.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    if (!last) {
        return formatted.trim();
    }
    return `${formatted}.${last}`.trim();
};

export const getCurrencyIcon = (currency) => {
    if (!currency) {
        return null;
    }
    return (CURRENCY_SYMBOLS[currency] || {})?.icon;
};
export const getCurrencyText = (currency) => {
    if (!currency) {
        return CURRENCY_SYMBOLS['RUB'].text;
    }
    return (CURRENCY_SYMBOLS[currency] || {}).text || currency;
};

export const currencyAsString = (value, currencyId, context = {}) => {
    if (!currencyId) {
        return baseCurrency(getFloat(value));
    }
    try {
        return `${value} ${CURRENCY_SYMBOLS[currencyId].text}`;
    } catch (error) {
        try {
            if (CURRENCY_SYMBOLS[currencyId]) {
                return `${baseCurrency(getFloat(value))} ${CURRENCY_SYMBOLS[currencyId].text}`;
            } else {
                return `${baseCurrency(getFloat(value))} ${currencyId}`;
            }
        } catch (error) {
            return `${baseCurrency(getFloat(value))} ${currencyId}`;
        }
    }
};